export enum EmailReferralTag {    
    Donor = 1,
    Patient = 2
}